import { useState, useCallback, useRef } from 'react'

interface UseDataTableScrollReturn {
  isScrolledX: boolean
  handleScroll: (instance: { elements: () => { viewport: HTMLElement | null } }) => void
}

export function useDataTableScroll(): UseDataTableScrollReturn {
  const [isScrolledX, setIsScrolledX] = useState(false)
  const lastScrolledRef = useRef(false)

  const handleScroll = useCallback((instance: { elements: () => { viewport: HTMLElement | null } }) => {
    const viewport = instance.elements().viewport
    if (viewport) {
      const isScrolled = viewport.scrollLeft > 0
      if (isScrolled !== lastScrolledRef.current) {
        lastScrolledRef.current = isScrolled
        setIsScrolledX(isScrolled)
      }
    }
  }, [])

  return {
    isScrolledX,
    handleScroll
  }
}
